module.exports = __webpack_public_path__ + "img/remove-icon.57c00eb2.svg";